import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}

const variantStyles = {
  primary: css`
    background-color: ${theme.colors.primary};
    color: ${theme.colors.text.inverse};
    border: 2px solid ${theme.colors.primary};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.primaryDark};
      border-color: ${theme.colors.primaryDark};
      color: ${theme.colors.text.inverse};
    }
  `,
  secondary: css`
    background-color: transparent;
    color: ${theme.colors.primary};
    border: 2px solid ${theme.colors.primary};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.primary};
      color: ${theme.colors.text.inverse};
    }
  `,
  ghost: css`
    background-color: transparent;
    color: ${theme.colors.text.primary};
    border: 2px solid transparent;

    &:hover:not(:disabled) {
      background-color: ${theme.colors.surface};
    }
  `,
};

const sizeStyles = {
  small: css`
    padding: ${theme.spacing.xs} ${theme.spacing.md};
    font-size: ${theme.fontSizes.sm};
  `,
  medium: css`
    padding: ${theme.spacing.sm} ${theme.spacing.lg};
    font-size: ${theme.fontSizes.base};
  `,
  large: css`
    padding: ${theme.spacing.md} ${theme.spacing.xl};
    font-size: ${theme.fontSizes.lg};
  `,
};

export const Button = styled.button<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border-radius: ${theme.radii.md};
  transition: all ${theme.transitions.fast};
  cursor: pointer;
  outline: none;
  text-decoration: none;
  white-space: nowrap;
  
  ${props => variantStyles[props.variant || 'primary']}
  ${props => sizeStyles[props.size || 'medium']}
  ${props => props.fullWidth && css`width: 100%;`}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px ${theme.colors.primaryLight}40;
  }
`;